let apiUrl
const apiUrls = {
  production: 'https://project-event-planner.herokuapp.com',
  development: 'http://localhost:8000'

}

if (window.location.hostname === 'localhost') {
  apiUrl = apiUrls.development
} else {
  apiUrl = apiUrls.production
}

export default apiUrl



// WEBPACK FOOTER //
// ./src/apiConfig.js